import { useState, useEffect } from "react";
import { getWithExpiry } from "@zf/react-frontend-vite";

const useCheckAgent = () => {
  const [isAgent, setAgent] = useState(getWithExpiry("isAgent"));
  useEffect(() => {
    setAgent(getWithExpiry("isAgent"));
  }, [getWithExpiry("isAgent")]);

  return isAgent;
};

export default useCheckAgent;
